// Frontend config: controls which partners use partner-style tracker display
// Adding a new partner = add config here + backend RAW_PARTNER_STATUS_CONFIG
export const PARTNER_DISPLAY_CONFIG = {
  spx: {
    trackerUrl: (etn) => `https://spx.sg/track?${etn}`,
    fields: {
      description: { key: 'message' },
      statusLabel: { key: 'status' },
      timestamp: { key: 'timestamp', formatter: (v) => new Date(v * 1000) },
    },
    trackButtonStyles: {
      backgroundColor: '#EE4D2D',
      color: '#fff',
      padding: '4px 12px',
      borderRadius: '4px',
    },
  },
};

export function getField(partnerData, fieldConfig) {
  const raw = partnerData[fieldConfig.key];
  return fieldConfig.formatter ? fieldConfig.formatter(raw, partnerData) : raw;
}

export function getPartnerDisplayInfo(externalTrackingNos) {
  const entries = Object.entries(externalTrackingNos || {});
  if (entries.length !== 1) return null;
  const [partnerName, etn] = entries[0];
  const config = PARTNER_DISPLAY_CONFIG[partnerName];
  if (!config) return null;
  return { partnerName, etn, config };
}
